import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { notifyParentOfRouteChange } from '@/lib/app-messaging'

/**
 * Client component that automatically tracks route changes and notifies the parent window.
 * This should be added to the root layout to enable automatic route tracking across the entire app.
 * Only sends notifications when the URL actually changes, preventing duplicates.
 */
export function RouteTracker() {
  const location = useLocation()
  const previousUrl = useRef<string | undefined>(undefined)

  useEffect(() => {
    // Construct the full path including search params
    const fullPath = location.pathname + location.search

    // Only notify if the URL has actually changed
    if (previousUrl.current !== undefined && previousUrl.current !== fullPath) {
      notifyParentOfRouteChange(fullPath)
    }

    // Update the previous URL for next comparison
    previousUrl.current = fullPath
  }, [location.pathname, location.search])

  return null // This component doesn't render anything
} 